<template>
  <div class="app-layout">
    <SidebarNav
      :is-open="isSidebarOpen"
      :active-tab="activeTab"
      @close="closeSidebar"
      @navigate="navigateToTab"
      @open-settings="openSettingsModal"
    />
    <button @click="openSidebar" class="hamburger-btn" title="Open Menu">
      <span class="material-icons">menu</span>
    </button>
    <main class="main-content">
      <TaskList v-show="activeTab === 'contabilidad'" ref="taskList" />
      <MapView v-show="activeTab === 'mapa'" />
      <ActivityLog v-show="activeTab === 'actividades'" />
      <Notes v-show="activeTab === 'notas'" ref="notes" />
    </main>
    <div
      v-if="isSidebarOpen"
      @click="closeSidebar"
      class="sidebar-overlay"
    ></div>
    <SettingsModal
      v-if="isSettingsModalVisible"
      @close="closeSettingsModal"
      :task-list="$refs.taskList"
      :notes="$refs.notes"
    />
  </div>
</template>

<script>
import TaskList from './components/TaskList.vue'
import MapView from './components/MapView.vue'
import ActivityLog from './components/ActivityLog.vue'
import Notes from './components/Notes.vue'
import SidebarNav from './components/Sidebar.vue'
import SettingsModal from './components/SettingsModal.vue'

export default {
  name: 'App',
  components: {
    TaskList,
    MapView,
    ActivityLog,
    Notes,
    SidebarNav,
    SettingsModal,
  },
  data() {
    return {
      activeTab: 'contabilidad',
      isSidebarOpen: false,
      isSettingsModalVisible: false,
    }
  },
  methods: {
    navigateToTab(tab) {
      this.activeTab = tab
      this.closeSidebar() // Close sidebar after navigation
    },
    openSidebar() {
      this.isSidebarOpen = true
    },
    closeSidebar() {
      this.isSidebarOpen = false
    },
    openSettingsModal() {
      this.isSettingsModalVisible = true
      // Close the sidebar when opening the modal for a cleaner UI
      this.isSidebarOpen = false
    },
    closeSettingsModal() {
      this.isSettingsModalVisible = false
    },
  },
}
</script>

<style>
/* Global styles to prevent blue overscroll and fix mobile viewport */
* {
  -webkit-tap-highlight-color: transparent;
}

html,
body {
  background-color: #202225 !important;
  margin: 0;
  padding: 0;
  height: 100vh;
  height: 100dvh; /* Dynamic viewport height for mobile */
  overscroll-behavior: none !important;
  -webkit-overscroll-behavior: none !important;
  overflow-x: hidden;
}

/* Prevent mobile Safari bounce and address bar issues */
body {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

/* Ensure app container fills viewport */
#app {
  height: 100vh;
  height: 100dvh;
  background-color: #202225 !important;
  overflow-y: auto;
  position: relative;
}

/* Force all scrollable areas to use our background */
::-webkit-scrollbar {
  background-color: #202225 !important;
}

::-webkit-scrollbar-track {
  background-color: #202225 !important;
}

::-webkit-scrollbar-thumb {
  background-color: #4f545c !important;
  border-radius: 4px;
}

/* Override any system defaults that might show blue */
::selection {
  background-color: #4f545c !important;
}

::-moz-selection {
  background-color: #4f545c !important;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
  background-color: #202225;
  color: #dcddde;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, sans-serif;
  background-color: #202225;
}

.app-layout {
  display: flex;
  min-height: 100vh;
  background-color: #202225;
  position: relative;
}

/* Add top padding when running as standalone PWA */
@media (display-mode: standalone) {
  .app-layout {
    padding-top: env(safe-area-inset-top, 44px);
  }
}

.main-content {
  flex-grow: 1;
  background-color: #202225;
}

/* Ensure main content has proper spacing in PWA mode */
@media (display-mode: standalone) {
  .main-content {
    padding-top: 0px;
  }
}

.hamburger-btn {
  position: absolute;
  top: 36px; /* Align with header content */
  left: 20px;
  z-index: 100;
  background: #2f3136;
  border: none;
  color: #dcddde;
  cursor: pointer;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  transition: background-color 0.2s;
}

/* Adjust hamburger button position for PWA mode */
@media (display-mode: standalone) {
  .hamburger-btn {
    top: 36px !important;
  }
}

.hamburger-btn:hover {
  background-color: #40444b;
}

.sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1001;
}

@media (max-width: 768px) {
  body {
    overflow-x: hidden;
    overflow-y: auto;
  }

  .app-layout {
    min-height: 100vh;
    flex-direction: column;
  }

  .main-content {
    margin-left: 0;
  }
}

/* Tablet landscape optimizations */
@media (min-width: 769px) and (max-width: 1024px) and (orientation: landscape) {
  .hamburger-btn {
    top: 20px;
    left: 20px;
  }

  .main-content {
    padding: 0;
  }
}
</style>
